import { css } from 'styled-components';
import { getFormattedSpaceValue } from './getFormattedSpaceValue';
export const padding = css `
  ${({ $p, $pt, $pb, $pl, $pr, $px, $py }) => `
		${$p ? `padding: ${getFormattedSpaceValue($p)};` : ''}
		${$pt ? `padding-top: ${getFormattedSpaceValue($pt)};` : ''}
		${$pb ? `padding-bottom: ${getFormattedSpaceValue($pb)};` : ''}
		${$pl ? `padding-left: ${getFormattedSpaceValue($pl)};` : ''}
		${$pr ? `padding-right: ${getFormattedSpaceValue($pr)};` : ''}
		${$px
    ? `
			padding-right: ${getFormattedSpaceValue($px)};
			padding-left: ${getFormattedSpaceValue($px)};
		`
    : ''}
		${$py
    ? `
			padding-top: ${getFormattedSpaceValue($py)};
			padding-bottom: ${getFormattedSpaceValue($py)};
		`
    : ''}
	`}
`;
export const paddingKeys = [
    'p',
    'pt',
    'pb',
    'pl',
    'pr',
    'px',
    'py',
];
